// /data/mock-slides-data.ts
// ✅ Mock slides data
import { Slide } from "@/components/promo-carousel";

export const mockSlides: Slide[] = [
{
    title: "MÉXICO DE ORO",
    subtitle: "",
    description: "The adidas x México Third Jersey collection, inspired by the splendor of Mexican music and art.",
    image: "/assets/resource/hp_1ca41e3ff1.jpg",
    cta: "SHOP NOW",
    href: "/club_america%7Cmexico",
},
{
    title: "BACK TO SCHOOL MUST HAVES",
    subtitle: "",
    description: "Shop trending back to school styles for everyone from the 3-Stripes.",
    image: "/assets/resource/xcat_fw25_bts_tcc_htt_mw_d_539f2055e6.jpeg",
    cta: "SHOP NOW",
    href: "/back_to_school",
},
{
    title: "ADIZERO EVO SL",
    subtitle: "",
    description: "Feel fast. In all aspects of life.",
    image: "/assets/resource/running_fw25_adizero_evo_sl_card_launch_d_a5b8e55d93.jpg?height=400&width=300",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "TAEKWONDO: NEW AGE CLASSIC",
    subtitle: "",
    description: "The low profile style everyone is talking about.",
    image: "/assets/resource/originals_fw25_taekwondo_card_sustain_d_12978e639b.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "REAL MADRID 25/26 AWAY JERSEY",
    subtitle: "",
    description: "Bring the Bernabéu Stadium to them.",
    image: "/assets/resource/global_aclubs_away_realmadrid_football_fw25_launch_teaser_d_cd74d54f99.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
},
{
    title: "DROPSET 3",
    subtitle: "",
    description: "Rooted in Strength.",
    image: "/assets/resource/global_dropset_training_fw25_launch_hp_catlp_navigation_card_teaser_2_d_7051bb5ba3.jpg",
    cta: "SHOP NOW",
    href: "/superstar",
}
]
